import { BInfiniteScroll } from '@bigin/components/infinite-scroll'
import { BLoading } from '@bigin/components/loading'
import { BMessage } from '@bigin/components/message'
import { BMessageBox } from '@bigin/components/message-box'
import { BNotification } from '@bigin/components/notification'
import { BPopoverDirective } from '@bigin/components/popover'

import type { Plugin } from 'vue'

export default [
  BInfiniteScroll,
  BLoading,
  BMessage,
  BMessageBox,
  BNotification,
  BPopoverDirective,
] as Plugin[]
